export class UpdatePipelineRequest {
  public pipelineSectionId: number;
  public diameter: number;
  public trackingFileName: string | null;
  public trackingFile: string | null;

  public constructor(
    pipelineSectionId: number,
    diameter: number,
    trackingFileName: string | null,
    trackingFile: string | null
  ) {
    this.pipelineSectionId = pipelineSectionId;
    this.diameter = diameter;
    this.trackingFileName = trackingFileName;
    this.trackingFile = trackingFile;
  }
}
